import CSVFileValidator from 'csv-file-validator'
import SharedModal from '../../../sharedComponent/SharedModal'
import CustomButton from '../../../sharedComponent/CustomButton'
import DragDrop from '../../../sharedComponent/UploadDrag'
import {useEffect, useState} from 'react'
import {
  CREATE_BULK_PRODUCTS,
  GETPRODUCTSETUP,
  GET_ALL_SCRIPTS_LIST,
} from '../../../../utils/GraphQLAPI'
import {useLazyQuery, useMutation} from '@apollo/client'
import succesIcon from '../../../../_metronic/images/successIcon.svg'
import {ENUMS} from '../../../../utils/GlobalEnum'
import {GLOBAL_CONSTANTS} from '../../../../utils/GlobalConstants'
import {billingMethodOptions} from './ProductModal/AddProductUtils'

import moment from 'moment'

import {DownloadTemplate} from '../../../sharedComponent/DownloadTemplate/DownloadTemplate'
import {alert} from '../../../../utils/helper'
import _ from 'lodash'
import {ParsedValueType} from './UploadProductsUtils'

type UploadProductsType = {
  showModal: boolean
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>
  refetchProduct: () => void
}
const validate = (value: any, row: any, checkType: string, toCheckArray?: any) => {
  switch (checkType) {
    case 'ELECTRICREQUIREDANDCHECKTHEVALUEINPRODUCTSETUP':
      if (
        (row.includes(ENUMS.product.commodity.Electric) ||
          row.includes(ENUMS.product.commodity.Dual)) &&
        Boolean(value)
      ) {
        return toCheckArray.includes(value)
      } else if (row.includes(ENUMS.product.commodity.Gas)) {
        return true
      } else {
        return false
      }
    case 'ELECTRICREQUIRED':
      if (
        (row.includes(ENUMS.product.commodity.Electric) ||
          row.includes(ENUMS.product.commodity.Dual)) &&
        Boolean(value)
      ) {
        return true
      } else if (row.includes(ENUMS.product.commodity.Gas)) {
        return true
      } else {
        return false
      }
    case 'ELECTRICOPTIONAL':
      if (
        (row.includes(ENUMS.product.commodity.Electric) ||
          row.includes(ENUMS.product.commodity.Dual)) &&
        (Boolean(value) || !Boolean(value))
      ) {
        return true
      } else if (row.includes(ENUMS.product.commodity.Gas)) {
        return true
      } else {
        return false
      }
    case 'GASOPTIONAL':
      if (
        (row.includes(ENUMS.product.commodity.Gas) || row.includes(ENUMS.product.commodity.Dual)) &&
        (Boolean(value) || !Boolean(value))
      ) {
        return true
      } else if (row.includes(ENUMS.product.commodity.Electric)) {
        return true
      } else {
        return false
      }
    case 'GASREQUIREDANDCHECKTHEVALUEINPRODUCTSETUP':
      if (
        (row.includes(ENUMS.product.commodity.Gas) || row.includes(ENUMS.product.commodity.Dual)) &&
        Boolean(value)
      ) {
        return toCheckArray.includes(value)
      } else if (row.includes(ENUMS.product.commodity.Electric)) {
        return true
      } else {
        return false
      }
    case 'GASREQUIRED':
      if (
        (row.includes(ENUMS.product.commodity.Gas) || row.includes(ENUMS.product.commodity.Dual)) &&
        Boolean(value)
      ) {
        return true
      } else if (row.includes(ENUMS.product.commodity.Electric)) {
        return true
      } else {
        return false
      }
  }
}

const UploadProducts = ({showModal, setShowModal, refetchProduct}: UploadProductsType) => {
  // Get product details query
  const [getProductSetup, {data: productDetails}] = useLazyQuery(GETPRODUCTSETUP, {
    onCompleted: (resData) => {},
    fetchPolicy: 'network-only',
  })
  const [getAllScripts, {data: scripts}] = useLazyQuery(GET_ALL_SCRIPTS_LIST, {
    fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
    variables: {
      getScriptsInput: {
        isActive: true,
      },
    },
  })
  const [createBulkProduct] = useMutation(CREATE_BULK_PRODUCTS, {
    onCompleted: (data) => {
      refetchProduct()
    },
    onError: (err) => alert(err.message, 'error'),
    fetchPolicy: GLOBAL_CONSTANTS.networkOnlyMutation,
  })

  useEffect(() => {
    getProductSetup()
    getAllScripts()
  }, [])
  const handleModalClose = () => {
    setShowModal(false)
    setFile(null)
    setErrorMsg('')
  }

  const [file, setFile] = useState<File | null>(null)
  const [errorMsg, setErrorMsg] = useState('')
  const [parsedValues, setParsedValues] = useState<any>([])
  console.log(errorMsg, file, Boolean(errorMsg), Boolean(file))
  useEffect(() => {
    if (file) {
      const commodityValues = productDetails.getProductDetail
        .filter((data: any) => data.enum === ENUMS.productSetup.commodity)[0]
        .names.map((name: any) => name.value)
      const customerTypeValues = productDetails.getProductDetail
        .filter((data: any) => data.enum === ENUMS.productSetup.customerType)[0]
        .names.map((name: any) => name.value)
      const unitValues = productDetails.getProductDetail
        .filter((data: any) => data.enum === ENUMS.productSetup.unit)[0]
        .names.map((name: any) => name.value)
      const brandValues = productDetails.getProductDetail
        .filter((data: any) => data.enum === ENUMS.productSetup.brand)[0]
        .names.map((name: any) => name.value)
      const contractTypeValues = productDetails.getProductDetail
        .filter((data: any) => data.enum === ENUMS.productSetup.contractType)[0]
        .names.map((name: any) => name.value)
      const utilitiesValues = productDetails.getProductDetail
        .filter((data: any) => data.enum === ENUMS.productSetup.utility)[0]
        .names.map((name: any) => name.value)
      const scriptNames = scripts.getAllScripts.scripts.map((script: any) => script.scriptName)
      console.log(unitValues)
      const config: any = {
        headers: [
          {
            name: 'Product Name',
            inputName: 'name',
            required: true,
            requiredError: function (headerName: string, rowNumber: number, columnNumber: number) {
              return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
            },
          },
          {
            name: 'Status',
            inputName: 'isActive',
            required: true,
            requiredError: function (headerName: string, rowNumber: number, columnNumber: number) {
              return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
            },
            validate: (isActive: string) => {
              if (
                isActive.toLocaleLowerCase() === 'active' ||
                isActive.toLocaleLowerCase() === 'inactive'
              ) {
                return true
              } else {
                return false
              }
            },
            validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
              `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
          },
          {
            name: 'Commodity',
            inputName: 'commodityId',
            required: true,
            requiredError: function (headerName: string, rowNumber: number, columnNumber: number) {
              return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
            },
            validate: (commodity: string) => {
              return commodityValues.includes(commodity)
            },
            validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
              `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
          },
          {
            name: 'Brand',
            inputName: 'brandTypeId',
            required: false,
            validate: (brand: string) => {
              if (Boolean(brand)) {
                return brandValues.includes(brand)
              } else {
                return true
              }
            },
            validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
              `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
          },
          {
            name: 'Customer Type',
            inputName: 'customerTypeId',
            required: true,
            validate: (brand: string) => {
              if (Boolean(brand)) {
                return customerTypeValues.includes(brand)
              } else {
                return false
              }
            },
            validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
              `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
          },
          {
            name: 'Script Name',
            inputName: 'scriptId',
            required: false,
            validate: (scriptName: string) => {
              if (Boolean(scriptName)) {
                return scriptNames.includes(scriptName)
              } else {
                return true
              }
            },
            validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
              `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
          },
          {
            name: 'E_Utility',
            inputName: 'utilityId',
            required: false,
            validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
              `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
            dependentValidate: (value: string, row: any) => {
              return validate(
                value,
                row,
                'ELECTRICREQUIREDANDCHECKTHEVALUEINPRODUCTSETUP',
                utilitiesValues
              )
            },
          },
          {
            name: 'E_Contract Type',
            inputName: 'contractTypeId',
            required: false,

            validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
              `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
            dependentValidate: (value: string, row: any) => {
              return validate(
                value,
                row,
                'ELECTRICREQUIREDANDCHECKTHEVALUEINPRODUCTSETUP',
                contractTypeValues
              )
            },
          },
          {
            name: 'E_Unit',
            inputName: 'unitTypeId',
            required: false,
            validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
              `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
            dependentValidate: (value: string, row: any) =>
              validate(value, row, 'ELECTRICREQUIREDANDCHECKTHEVALUEINPRODUCTSETUP', unitValues),
          },
          {
            name: 'E_Rate',
            inputName: 'rate',
            required: false,
            validate: (grate: string) => {
              if (isNaN(Number(grate)) || Number(grate) < 0) {
                return false
              }
              return true
            },
            validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
              `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
          },
          {
            name: 'E_Second Rate',
            inputName: 'secondRate',
            required: false,
            validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
              `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
            dependentValidate: (value: string, row: any) =>
              validate(value, row, 'ELECTRICOPTIONAL'),
          },
          {
            name: 'E_Term',
            inputName: 'term',
            required: false,
            validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
              `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
            dependentValidate: (value: string, row: any) =>
              validate(value, row, 'ELECTRICOPTIONAL'),
          },

          {
            name: 'E_Early Termination Fee',
            inputName: 'earlyTerminationFee',
            required: false,
            validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
              `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
            dependentValidate: (value: string, row: any) =>
              validate(value, row, 'ELECTRICOPTIONAL'),
          },
          {
            name: 'E_Service Fee',
            inputName: 'serviceFee',
            required: false,
            validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
              `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
            dependentValidate: (value: string, row: any) =>
              validate(value, row, 'ELECTRICOPTIONAL'),
          },
          {
            name: 'E_Adder',
            inputName: 'adder',
            required: false,
            validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
              `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
            dependentValidate: (value: string, row: any) =>
              validate(value, row, 'ELECTRICOPTIONAL'),
          },
          {
            name: 'E_Deposit',
            inputName: 'deposit',
            required: false,
            validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
              `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
            dependentValidate: (value: string, row: any) =>
              validate(value, row, 'ELECTRICOPTIONAL'),
          },
          {
            name: 'E_Product Code',
            inputName: 'ecode',
            required: false,
            validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
              `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
            dependentValidate: (value: string, row: any) =>
              validate(value, row, 'ELECTRICREQUIRED'),
          },
          {
            name: 'E_Billing Method',
            inputName: 'ebillingMethod',
            required: false,
            validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
              `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
            dependentValidate: (value: string, row: any) =>
              validate(
                value,
                row,
                'ELECTRICREQUIRED',
                billingMethodOptions.map((data) => data.value)
              ),
          },

          {
            name: 'G_Utility',
            inputName: 'gutilityId',
            required: false,
            validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
              `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
            dependentValidate: (value: string, row: any) => {
              return validate(
                value,
                row,
                'GASREQUIREDANDCHECKTHEVALUEINPRODUCTSETUP',
                utilitiesValues
              )
            },
          },
          {
            name: 'G_Contract Type',
            inputName: 'gcontractTypeId',
            required: false,
            validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
              `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
            dependentValidate: (value: string, row: any) => {
              return validate(
                value,
                row,
                'GASREQUIREDANDCHECKTHEVALUEINPRODUCTSETUP',
                contractTypeValues
              )
            },
          },
          {
            name: 'G_Unit',
            inputName: 'gunitTypeId',
            required: false,
            validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
              `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
            dependentValidate: (value: string, row: any) =>
              validate(value, row, 'GASREQUIREDANDCHECKTHEVALUEINPRODUCTSETUP', unitValues),
          },
          {
            name: 'G_Rate',
            inputName: 'grate',
            required: false,
            validate: (grate: string) => {
              if (isNaN(Number(grate)) || Number(grate) < 0) {
                return false
              }
              return true
            },
            validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
              `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
          },
          {
            name: 'G_Second Rate',
            inputName: 'gsecondRate',
            required: false,
            validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
              `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
            dependentValidate: (value: string, row: any) => validate(value, row, 'GASOPTIONAL'),
          },
          {
            name: 'G_Term',
            inputName: 'gterm',
            required: false,
            validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
              `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
            dependentValidate: (value: string, row: any) => validate(value, row, 'GASOPTIONAL'),
          },
          {
            name: 'G_Early Termination Fee',
            inputName: 'gearlyTerminationFee',
            required: false,
            validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
              `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
            dependentValidate: (value: string, row: any) => validate(value, row, 'GASOPTIONAL'),
          },

          {
            name: 'G_Service Fee',
            inputName: 'gserviceFee',
            required: false,
            validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
              `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
            dependentValidate: (value: string, row: any) => validate(value, row, 'GASOPTIONAL'),
          },
          {
            name: 'G_Adder',
            inputName: 'gadder',
            required: false,
            validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
              `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
            dependentValidate: (value: string, row: any) => validate(value, row, 'GASOPTIONAL'),
          },
          {
            name: 'G_Deposit',
            inputName: 'gdeposit',
            required: false,
            validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
              `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
            dependentValidate: (value: string, row: any) => validate(value, row, 'GASOPTIONAL'),
          },
          {
            name: 'G_Product Code',
            inputName: 'gcode',
            required: false,
            validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
              `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
            dependentValidate: (value: string, row: any) => validate(value, row, 'GASREQUIRED'),
          },
          {
            name: 'G_Billing Method',
            inputName: 'gbillingMethod',
            required: false,
            validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
              `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
            dependentValidate: (value: string, row: any) =>
              validate(
                value,
                row,
                'GASREQUIRED',
                billingMethodOptions.map((data) => data.value)
              ),
          },
          {
            name: 'Start Date',
            inputName: 'startDate',
            required: false,
            validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
              `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
            validate: (startDate: Date) => {
              return true
            },
          },
          {
            name: 'End Date',
            inputName: 'endDate',
            required: false,
            validateError: (headerName: string, rowNumber: number, columnNumber: number) =>
              `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`,
            validate: (endDate: Date) => {
              return true
            },
          },
          {
            name: 'Additional Information',
            inputName: 'notes',
            required: false,
            optional: true,
          },
          // {
          //     name: 'Email',
          //     inputName: 'email',
          //     unique: true,
          //     uniqueError: function (headerName:string) {
          //         return `${headerName} is not unique`
          //     },
          //     validate: function(email:string) {
          //         return isEmailValid(email)
          //     },
          //     validateError: function (headerName:string, rowNumber:number, columnNumber:number) {
          //         return `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`
          //     }
          // },
          // {
          //     name: 'Country',
          //     inputName: 'country',
          //     optional: true,
          //     dependentValidate: function(email:string, row:any) {
          //         return isEmailDependsOnSomeDataInRow(email, row);
          //     }
          // }
        ],
      }
      CSVFileValidator(file, config)
        .then((csvData) => {
          console.log(csvData.data, csvData.inValidData) // Array of objects from file

          // Array of error messages
          if (csvData.inValidData.length) {
            setErrorMsg(csvData.inValidData[0].message)
            setFile(null)
          } else {
            setParsedValues(csvData.data)
            setErrorMsg('')
          }
        })
        .catch((err) => {})
    }
  }, [file])
  const handleSubmit = async () => {
    const commodityValues = productDetails.getProductDetail.filter(
      (data: any) => data.enum === ENUMS.productSetup.commodity
    )[0].names
    const customerTypeValues = productDetails.getProductDetail.filter(
      (data: any) => data.enum === ENUMS.productSetup.customerType
    )[0].names
    const unitValues = productDetails.getProductDetail.filter(
      (data: any) => data.enum === ENUMS.productSetup.unit
    )[0].names
    const brandValues = productDetails.getProductDetail.filter(
      (data: any) => data.enum === ENUMS.productSetup.brand
    )[0].names
    const contractTypeValues = productDetails.getProductDetail.filter(
      (data: any) => data.enum === ENUMS.productSetup.contractType
    )[0].names
    const utilitiesValues = productDetails.getProductDetail.filter(
      (data: any) => data.enum === ENUMS.productSetup.utility
    )[0].names

    let payload = parsedValues.map((parsedValue: ParsedValueType) => ({
      ...parsedValue,
      productType: parsedValue.commodityId.toUpperCase(),
      isActive: parsedValue.isActive.toLowerCase() === 'active' ? true : false,
      commodityId: Boolean(parsedValue.commodityId)
        ? commodityValues.filter((data: any) => data.value === parsedValue.commodityId)[0].id
        : null,
      brandTypeId: Boolean(parsedValue?.brandTypeId)
        ? brandValues.filter((data: any) => data.value === parsedValue.brandTypeId)[0].id
        : null,

      customerTypeId: customerTypeValues.filter(
        (data: any) => data.value === parsedValue.customerTypeId
      )[0].id,
      scriptId: Boolean(parsedValue?.scriptId)
        ? scripts.getAllScripts.scripts.filter(
            (script: any) => script.scriptName === parsedValue?.scriptId
          )[0].scriptId
        : null,
      startDate: Boolean(parsedValue?.startDate)
        ? moment.utc(parsedValues.startDate).format()
        : null,
      endDate: Boolean(parsedValue?.endDate) ? moment.utc(parsedValues.endDate).format() : null,
      utilityId: Boolean(parsedValue?.utilityId)
        ? utilitiesValues.filter((data: any) => data.value === parsedValue?.utilityId)[0].id
        : null,
      contractTypeId: Boolean(parsedValue?.contractTypeId)
        ? contractTypeValues.filter((data: any) => data.value === parsedValue?.contractTypeId)[0].id
        : null,
      unit: Boolean(parsedValue?.unitTypeId) ? parsedValue?.unitTypeId : null,
      unitTypeId: Boolean(parsedValue?.unitTypeId)
        ? unitValues.filter((data: any) => data.value === parsedValue?.unitTypeId)[0].id
        : null,
      rate: Boolean(parsedValue?.rate) ? Number(parsedValue?.rate) : null,
      secondRate: Boolean(parsedValue?.secondRate) ? Number(parsedValue?.secondRate) : null,
      term: Boolean(parsedValue?.term) ? parsedValue?.term : null,
      earlyTerminationFee: Boolean(parsedValue?.earlyTerminationFee)
        ? Number(parsedValue?.earlyTerminationFee)
        : null,
      serviceFee: Boolean(parsedValue?.serviceFee) ? Number(parsedValue?.serviceFee) : null,
      adder: Boolean(parsedValue?.adder) ? Number(parsedValue?.adder) : null,
      deposit: Boolean(parsedValue?.deposit) ? Number(parsedValue?.deposit) : null,
      ecode: Boolean(parsedValue?.ecode) ? parsedValue?.ecode : null,
      ebillingMethod: Boolean(parsedValue?.ebillingMethod) ? parsedValue?.ebillingMethod : null,
      gcontractTypeId: Boolean(parsedValue?.gcontractTypeId)
        ? contractTypeValues.filter((data: any) => data.value === parsedValue?.gcontractTypeId)[0]
            .id
        : null,
      gutilityId: Boolean(parsedValue?.gutilityId)
        ? utilitiesValues.filter((data: any) => data.value === parsedValue?.gutilityId)[0].id
        : null,
      gunit: Boolean(parsedValue?.gunitTypeId) ? parsedValue?.gunitTypeId : null,
      gunitTypeId: Boolean(parsedValue?.gunitTypeId)
        ? unitValues.filter((data: any) => data.value === parsedValue?.gunitTypeId)[0].id
        : null,
      grate: Boolean(parsedValue?.grate) ? Number(parsedValue?.grate) : null,
      gsecondRate: Boolean(parsedValue?.gsecondRate) ? Number(parsedValue?.gsecondRate) : null,
      gterm: Boolean(parsedValue?.gterm) ? parsedValue?.gterm : null,
      gearlyTerminationFee: Boolean(parsedValue?.gearlyTerminationFee)
        ? Number(parsedValue?.gearlyTerminationFee)
        : null,
      gserviceFee: Boolean(parsedValue.gserviceFee) ? Number(parsedValue?.gserviceFee) : null,
      gadder: Boolean(parsedValue?.gadder) ? Number(parsedValue?.gadder) : null,
      gdeposit: Boolean(parsedValue?.gdeposit) ? Number(parsedValue?.gdeposit) : null,
      gcode: Boolean(parsedValue?.gcode) ? parsedValue?.gcode : null,
      gbillingMethod: Boolean(parsedValue?.gbillingMethod) ? parsedValue?.gbillingMethod : null,
    }))
    console.log('payloaad', payload)
    if (payload.length > 80) {
      const splitArrays = []
      for (let i = 0; i < payload.length; i += 80) {
        splitArrays.push(payload.slice(i, i + 80))
      }

      splitArrays.forEach((item) => {
        _.debounce(() => {
          console.log('in block')
          createBulkProduct({
            variables: {
              createProductInput: item,
            },
          })
        }, 500)()
      })
      payload = []
      handleModalClose()
      alert('Products uploaded successfully', 'success')
    } else {
      createBulkProduct({
        variables: {
          createProductInput: payload,
        },
      })
      payload = []
      handleModalClose()
      alert('Products uploaded successfully', 'success')
    }
  }
  return (
    <>
      <CustomButton
        text='Import'
        pathfromImages='uploadIcon.svg'
        className='btn btn-active-light-primary btn-active-icon-white btn-light-primary '
        onClick={() => setShowModal(true)}
      />
      <SharedModal
        handleClose={handleModalClose}
        className='mw-750px'
        handleSubmit={handleSubmit}
        show={showModal}
        headerName='Import Products'
        disableSubmit={Boolean(errorMsg) || parsedValues?.length === 0}
        headerContent={
          <DownloadTemplate
            href={process.env.REACT_APP_PRODUCT_TEMPLATE_DOWNLOAD}
            text='Download Template'
          />
        }
        submitText='Import'
      >
        <div className='p-4'>
          {/* <UploadCSV onUploadAccepted={(data) => console.log('data----', data)} /> */}
          <DragDrop
            setFile={setFile}
            file={file}
            label={'Click here to upload or drag and drop'}
            fileTypes={['csv']}
            customDragDropSection={
              <div className='d-flex h-100 justify-content-center align-items-center border-dashed border-1 border-gray-400'>
                <p className='text-danger'>{errorMsg}</p>
                {!Boolean(errorMsg) && !Boolean(file) && (
                  <p className=''>Click here to select file or drag and drop</p>
                )}
                {Boolean(file) && (
                  <div className='d-flex flex-column align-items-center'>
                    <img
                      width={35}
                      height={35}
                      className='m-auto mb-2'
                      src={succesIcon}
                      alt='success'
                    />
                    <p> File uploaded succesfully</p>
                  </div>
                )}
              </div>
            }
          />
        </div>
      </SharedModal>
    </>
  )
}
export default UploadProducts
